module.exports = __webpack_public_path__ + "static/media/eth-round-landing.c7517c8e.svg";